import dayjs from "dayjs";
import axios from "../../../../utils/axios-private";

export const getListSchedule = ({ pageNumber, pageSize }) => {
  const initialRequest = {
    limit: pageSize,
    page: pageNumber,
    start_booking_time: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_booking_time: dayjs().endOf("month").format("YYYY-MM-DD"),
  };
  return {
    type: "GET_LIST_SCHEDULE",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/jadwal/list`;
      axios
        .post(url, initialRequest, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
